export default __webpack_public_path__ + "static/media/check.2089ba3b.svg";